export const getLocationInfo = (location) => {
  const pathname = location?.pathname || ""
  const inStreamingPage = pathname.includes("streaming")
  const inStreamingMiniPage = pathname.includes("streaming_mini")
  const inInvitePage = pathname.includes("invite")
  const inHomepage = !inInvitePage && !inStreamingPage
  return {
    inStreamingPage,
    inHomepage,
    inInvitePage,
    inStreamingMiniPage: inStreamingMiniPage,
    inStreamingWorkshopPage: inStreamingPage && !inStreamingMiniPage,
  }
}
